const DEFAULT_API_BASE = "https://api.werbeauto.ch" as const;
const KNOWN_APP_SUBDOMAINS = ["admin", "advertiser", "demo", "idm", "api"] as const;
const KNOWN_APP_PREFIXES = [
  "admin",
  "admin-portal",
  "adminportal",
  "advertiser",
  "advertiser-portal",
  "advertiserportal",
  "demo",
  "demo-portal",
  "demoportal",
  "idm",
  "api",
] as const;

const normalizeBaseUrl = (value?: string) => {
  const normalized = typeof value === "string" ? value.trim() : "";
  return normalized ? normalized.replace(/\/$/, "") : "";
};

const deriveApiBaseFromHostname = (hostname: string, protocol: string) => {
  if (!hostname) {
    return "";
  }

  if (hostname === "localhost" || hostname === "127.0.0.1") {
    return "";
  }

  const segments = hostname.split(".").filter(Boolean);
  if (!segments.length) {
    return "";
  }

  const firstSegment = segments[0].toLowerCase();
  const baseSegments =
    (KNOWN_APP_SUBDOMAINS.includes(firstSegment as (typeof KNOWN_APP_SUBDOMAINS)[number]) ||
      KNOWN_APP_PREFIXES.includes(firstSegment as (typeof KNOWN_APP_PREFIXES)[number])) &&
    segments.length > 1
      ? segments.slice(1)
      : segments;

  if (!baseSegments.length) {
    return "";
  }

  return `${protocol}//api.${baseSegments.join(".")}`;
};

const envBase = normalizeBaseUrl(process.env.REACT_APP_API_BASE);
const runtimeBase =
  typeof window !== "undefined"
    ? deriveApiBaseFromHostname(window.location.hostname, window.location.protocol)
    : "";

export const API_BASE = envBase || runtimeBase || DEFAULT_API_BASE;
export const buildApiUrl = (path = "") =>
  path ? `${API_BASE}${path.startsWith("/") ? path : `/${path}`}` : API_BASE;
